import { render, staticRenderFns } from "./InterList.vue?vue&type=template&id=0d2d8fa4&scoped=true&"
import script from "./InterList.vue?vue&type=script&lang=js&"
export * from "./InterList.vue?vue&type=script&lang=js&"
import style0 from "./InterList.vue?vue&type=style&index=0&id=0d2d8fa4&prod&scoped=true&lang=css&"
import style1 from "./InterList.vue?vue&type=style&index=1&id=0d2d8fa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d8fa4",
  null
  
)

export default component.exports